/**
 * Computes the average and standard deviation for a date field (e.g., planting_date or harvest_date) for each year 2018-2024.
 * @param data Array of objects with <key>_YEAR fields
 * @param key The base key name (e.g., 'planting_date' or 'harvest_date')
 * @returns Object mapping year to { avg, stdev }
 */
export function computePlantingDateStats(
  data: any[],
  key: string
): Record<string, { avg: number; stdev: number }> {
  const years = [2018, 2019, 2020, 2021, 2022, 2023, 2024]
  const result: Record<string, { avg: number; stdev: number }> = {}
  for (const year of years) {
    const values = data
      .map(row => row[`${key}_${year}`])
      .filter(v => typeof v === 'number' && !isNaN(v))
    if (values.length === 0) {
      result[year] = { avg: NaN, stdev: NaN }
      continue
    }
    const avg = values.reduce((a, b) => a + b, 0) / values.length
    const stdev = Math.sqrt(
      values.reduce((sum, v) => sum + Math.pow(v - avg, 2), 0) / values.length
    )
    result[year] = { avg, stdev }
  }
  return result
}

// Example usage (uncomment to run as script):
// const data = JSON.parse(readFileSync('path/to/county_data.json', 'utf8'))
// console.log(computePlantingDateStats(data))
